export default "__VITE_PUBLIC_ASSET__46207598__"